<template>

<div class="cell small-12 large-10 ">
 
        <template v-if="bookmakeroffers && bookmakeroffers.length">


            <template v-if="ss == 'New_Customers'">
            <h1 class="qmajorheader" >{{langConv("New Customer Offers") }}</h1>
            <h2 class="cell qsubheader">{{langConv("All new customer offer available at your location")}}</h2>
            </template>

            <div v-for="(bo,i) in bookmakeroffers" :key="i">
                
         
                <div style="padding:5px" >

                    <div class="grid-x promoCard" style="text-align:center" v-if="ss == 'New_Customers_Brief'">
                      
                        <div class="cell"><a :href="'/bookmakerloader.html?bkm=' + bo.D + '&country=' + $store.state.countryname" target="_blank"><span v-bind:class="'b' + bo.D"></span></a></div>
                        <div class="cell qmediumboldfont text-center"  style="padding-top:4px"  v-html="bo.bantitle"></div>
                        
                        <div class="cell qsmallfontplus text-center" style="padding:2px 0px 4px 0px" v-html="bo.shortd" v-if="bo.shortd != bo.bantitle"></div>
            
                        <div class="grid-x qxsupersmallfont" style="margin-top:5px">
                            <template v-if="bo.freegamesrating">
                                <span class="cell auto"><span :class="[{ tick: true,qsmallcircularpop: true }]" ></span><span style="display:block; margin-top: 7px">{{ langConv('Free games')}}</span> </span>
                             </template>
                             <template v-if="bo.cashoutbets">
                                <span class="cell auto"><span :class="[{ tick: true,qsmallcircularpop: true }]"></span><span style="display:block; margin-top: 7px">{{ langConv('Cash out bets option')}}</span></span>
                             </template>
                             <template v-if="bo.upto100cashout">
                                <span class="cell auto"><span :class="[{ tick: true,qsmallcircularpop: true }]" v-if="bo.freegamesrating"></span><span style="display:block; margin-top: 7px">{{ langConv('100% cashout option')}}</span></span>
                             </template>
                             <template v-if="bo.firstclasssupport">
                                <span class="cell auto"><span :class="[{ tick: true,qsmallcircularpop: true }]" v-if="bo.freegamesrating"></span><span style="display:block; margin-top: 7px">{{ langConv('Industry best support')}}</span></span>
                             </template>
                             </div>  


                        <div class="cell" style="padding-top:5px">
                            <div class="grid-x">
                                <div class="cell auto"></div>
                                <div class="cell small-4"><actionbutton :bookmaker="bo.D"></actionbutton></div>
                                <div class="cell auto"></div>
                            </div>
                        </div>
                                               
                        <div v-if="elementvisible[i] && bo.tandcs.length > 0" class="cell" target="_blank"><a :href="bo.tandcs">{{ langConv('T and Cs apply') }}</a></div> 
                        
                    </div>
                   
                    <template v-if="ss == 'New_Customers'">
                        
<div class="promoCard grid-x align-middle">

    <div class="cell medium-2 small-12 text-center">
        <div class="cell" ><a :href="'/bookmakerloader.html?bkm=' + bo.D + '&country=' + $store.state.countryname"><span v-bind:class="'m' + bo.D"></span></a></div>
    
    </div>

    <div class="cell medium-7 small-12">

        <div class="promoTitle">
            <div class="cell qlargerfont" style="line-height:40px" v-html="bo.bantitle"></div>
        </div>

        <div class="promoSubTitle">
              <div class="grid-x qsmallfontplus1">
                            <template v-if="bo.freegamesrating">
                                <span class="cell shrink qsmallcircularpill">Free games </span>
                             </template>
                             <template v-if="bo.cashoutbets">
                                <span class="cell shrink qsmallcircularpill">Cash out bets option</span>
                             </template>
                             <template v-if="bo.upto100cashout">
                                <span class="cell shrink qsmallcircularpill">100% cashout option</span>
                             </template>
                             <template v-if="bo.firstclasssupport">
                                <span class="cell shrink qsmallcircularpill">Industry best support<span :class="[{ tick: true,qsmallcircularpop: true }]" v-if="bo.freegamesrating"></span></span>
                             </template>
                </div>  
        </div>

        <div class="promoDescription">
            <div class="qsmallfontplus1 qdarkgreylink" style="padding-bottom:10px" v-html="bo.shortd" v-if="bo.shortd != bo.bantitle"></div>
        </div>

        <div class="promoTerms">
            T&Cs apply | 18+ Gamble Responsibly
        </div>

    </div>

    <div STYLE="color:white;z-index:99999; line-height:2em;text-align: left" class="cell medium-3 small-12 text-center">

        <!-- <<a class="promoButton">
            Get Offer →
        </a>> -->
        <actionbutton fontsize="14px" :bookmaker="bo.D" ></actionbutton>
    </div>

</div>

 
                        <!-- <div class="grid-x grid-margin-x" style="text-align:center">
                            
                            <div class="cell" ><a :href="'/bookmakerloader.html?bkm=' + bo.D + '&country=' + $store.state.countryname"><span v-bind:class="'m' + bo.D"></span></a></div>
                            <div class="cell qlargerfont" style="line-height:40px" v-html="bo.bantitle"></div>
                        
                        </div>
                        <div style="text-align:center">
                            <div class="qsmallfontplus1 qdarkgreylink" style="padding-bottom:10px" v-html="bo.shortd" v-if="bo.shortd != bo.bantitle"></div>
                            <div class="grid-x qsmallfontplus1">
                            <template v-if="bo.freegamesrating">
                                <span class="cell auto">Free games <span :class="[{ tick: true,qsmallcircularpop: true }]"></span></span>
                             </template>
                             <template v-if="bo.cashoutbets">
                                <span class="cell auto">Cash out bets option<span :class="[{ tick: true,qsmallcircularpop: true }]"></span></span>
                             </template>
                             <template v-if="bo.upto100cashout">
                                <span class="cell auto">100% cashout option<span :class="[{ tick: true,qsmallcircularpop: true }]" v-if="bo.freegamesrating"></span></span>
                             </template>
                             <template v-if="bo.firstclasssupport">
                                <span class="cell auto">Industry best support<span :class="[{ tick: true,qsmallcircularpop: true }]" v-if="bo.freegamesrating"></span></span>
                             </template>
                             </div>  
                            <div class="qsmallfont" v-if="bo.tandcs.length > 0" target="_blank">{{ langConv('T and Cs apply') }}</div>
                            <div style="max-width:100px;margin:auto"><a :href="'/bookmakerloader.html?bkm=' + bo.D + '&country=' + $store.state.countryname" target="_blank" ><actionbutton :bookmaker="bo.D"></actionbutton></a></div> 
                        </div>
                        <hr style="margin:10px"> -->
                    
                    </template>

                </div>

            </div>

        </template>

        </div>

</template>

<script>

    //note: global gv not available in markup so convert to option as a local data const
    
  
    import { fetchData } from '/src/components/plugins/api.js'



    export default {
    name: "offers",
    metaInfo() {
         if (this.disableMeta) {
             return {}
          }
        const baseUrl = process.env.VUE_APP_WEBSITE || ''
        const path = (this.$route && this.$route.fullPath) ? this.$route.fullPath : '/'  
        return {
            title: this.langConv("New Bookmaker Account Offers"),
            meta: [{
        
                vmid: 'description',
                name: 'description',
                content: this.langConv("Thinking of using a new bookmaker. Get the best New Account Offers from Regulated Bookmakers")
            },
            {
                vmid: 'og:title',
                property: 'og:title',
                content:this.langConv("New Bookmaker Account Offers") 
            },    
            ],
            link: [{
                vmid: 'canonical',
                rel: 'canonical',
                href: baseUrl + path
            }]
        }
    },
           

    data: function () {
        return {
            bookmakeroffers: [],
            options: this.$screensize,
            ss: this.param1,
            elementvisible: [],
            smallbuttontext: "Show"
        };
    },
    async serverPrefetch() {
        await this.availableoffers()
    },

  
    components: {
     
    },
    async mounted() {
          if (!this.$store.state.wasSSR) {
        
            await this.availableoffers()
            }

    },


    props: {
        param1: { type: String, default: "New_Customers" },
        disableMeta: { type: Boolean, default: false}
    },
    methods: {
        toggle: function (itemno) {
            if (this.elementvisible[itemno] != true) {
                this.$set(this.elementvisible, itemno, true);
                this.smallbuttontext = "Close";
            }
            else {
                this.$set(this.elementvisible, itemno, false);
                this.smallbuttontext = "Show";
            }
        },
        async availableoffers() {

            var promotype

            if (this.param1 == 'All') {promotype = '2'} else {promotype = '1'}  

            const data =   await fetchData("AdvertService.svc/PromoOffersLongList", {

                    params: {
                        bannertypeID: promotype,
                        country: this.$store.state.countryname,
                        noitems: 20
                    }

            }).catch(error => {
                   console.log("axios error")
            });

            this.bookmakeroffers = JSON.parse(data);
            
        }
    }
    }
</script>


<style lang="scss">

@import "../../style/bkmmedium.css";

</style>

<style>

.bookmakerLogo{
    max-width:130px;
}

.promoTitle{
    font-size:24px;
    font-weight:700;
    color:#111;
    margin-bottom:8px;
}

.promoSubTitle{
    font-size:15px;
    color:#444;
    margin-bottom:8px;
}

.promoDescription{
    font-size:14px;
    color:#666;
    line-height:1.5;
}

.promoTerms{
    margin-top:10px;
    color:#999;
    font-size:12px;
}

/* .promoButton{
    background:#00a6ed;
    color:white;
    padding:14px 28px;
    border-radius:8px;
    font-weight:700;
    display:inline-block;
    transition:.2s;
}

.promoButton:hover{
    background:#008fd1;
} */


</style>


